import React from 'react';
import Head from 'next/head';
import { ErrorBoundary } from 'react-error-boundary';
import FadeAnimation from '../components/FadeAnimation/FadeAnimation';
import Home from '../components/home/Home';

export default function HomePage() {
  return (
    <>
      <Head>
        <title>Meit! | Inicio</title>
      </Head>
      <FadeAnimation>
        <ErrorBoundary fallbackRender={() => <h1>Hubo un error en Home</h1>}>
          <Home />
        </ErrorBoundary>
      </FadeAnimation>
    </>
  );
}
